import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { IOffering } from 'app/models';
import {
    IOfferingContact,
    IOfferingContactRequest,
    IOfferingContactRequestBase,
    IPartnerAccountingTotals,
    IPartnerLedgerItem,
    IPartnerUser,
    IPayoutDetail,
    ISendMotivationalNudgeRequest,
    ISendMotivationalNudgeResult,
    ITotals,
    IUserSearchResult,
} from '../models';
import { IApprovePayout } from '../models/approve-payout';
import { IDetailItemChange, IDetailItemMove } from '../models/offering/offering-summary';
import { IPartnerBase, IPartnerDeposit } from '../models/partner-base';
import { IPartnerTheme, IPartnerThemeView, PartnerThemeAssetType } from '../models/theme/partner-theme';
export const administrationStoreName = 'administration';

export const initializedHomeStoreAction = createAction(`[${administrationStoreName}] Initialize Coventry store`);
export const apiErrorAction = createAction(`[${administrationStoreName}] API Error`, props<{ method: string; error: string }>());

export const loadPaymentQueue = createAction(`[${administrationStoreName}] Load Payment Queue`);
export const getPaymentQueue = createAction(`[${administrationStoreName}] Get Payment Queue`, props<{ details: IPayoutDetail[] }>());
export const clearPaymentQueue = createAction(`[${administrationStoreName}] Clear Payment Queue`);

export const loadTotals = createAction(`[${administrationStoreName}] Load Totals`);
export const getTotals = createAction(`[${administrationStoreName}] Get  Totals`, props<{ totals: ITotals }>());
export const clearTotals = createAction(`[${administrationStoreName}] Clear  Totals`);

export const setPayoutStatus = createAction(`[${administrationStoreName}] Set Payout Status`, props<{ status: IApprovePayout }>());
export const setPayoutStatusSuccess = createAction(`[${administrationStoreName}] Set Payout Status Success`);

export const loadPayoutDocument = createAction(`[${administrationStoreName}] Load Payout Document`, props<{ payoutUuid: string; storageName: string }>());
export const getPayoutDocument = createAction(`[${administrationStoreName}] Get Payout Document`, props<{ documentUrl: string }>());
export const clearPayoutDocument = createAction(`[${administrationStoreName}] Clear Payout Document `);

export const loadPartners = createAction(`[${administrationStoreName}] Load Partners`, props<{ includeBeacon: boolean }>());
export const getPartners = createAction(`[${administrationStoreName}] Get  Partners`, props<{ partners: IPartnerBase[] }>());
export const clearPartners = createAction(`[${administrationStoreName}] Clear  Partners`);

export const setPartnerDeposit = createAction(`[${administrationStoreName}] Partner deposit`, props<{ deposit: IPartnerDeposit }>());
export const setPartnerDepositSuccess = createAction(`[${administrationStoreName}] Partner deposit success`);

export const loadPartnerAccoutingTotals = createAction(`[${administrationStoreName}] Load Partner Accouting Totals`, props<{ partnerUuid: string }>());
export const getPartnerAccoutingTotals = createAction(`[${administrationStoreName}] Get Partner Accouting Totals`, props<{ totals: IPartnerAccountingTotals }>());
export const clearPartnerAccoutingTotals = createAction(`[${administrationStoreName}] Clear Partner Accouting Totals `);

export const loadPartnerAccoutingItems = createAction(`[${administrationStoreName}] Load Partner Accouting Items`, props<{ partnerUuid: string }>());
export const getPartnerAccoutingItems = createAction(`[${administrationStoreName}] Get Partner Accouting Items`, props<{ items: IPartnerLedgerItem[] }>());
export const clearPartnerAccoutingItems = createAction(`[${administrationStoreName}] Clear Partner Accouting Items `);

export const loadTheme = createAction(`[${administrationStoreName}] Load Theme`, props<{ partnerUuid: string }>());
export const getTheme = createAction(`[${administrationStoreName}] Get  Theme`, props<{ theme: IPartnerThemeView }>());
export const clearTheme = createAction(`[${administrationStoreName}] Clear  Theme`);

export const saveTheme = createAction(`[${administrationStoreName}] Save Theme`, props<{ partnerUuid: string; payload: IPartnerTheme }>());
export const saveThemeSuccess = createAction(`[${administrationStoreName}] Save Theme success`, props<{ theme: IPartnerThemeView }>());

export const removeAsset = createAction(`[${administrationStoreName}] Remove Asset`, props<{ partnerUuid: string; assetType: PartnerThemeAssetType }>());
export const removeAssetSuccess = createAction(`[${administrationStoreName}] Upload Asset success`);

export const loadOfferings = createAction('[Offerings] Load Offerings', props<{ companyId: number }>());
export const loadOfferingsSuccess = createAction('[Offerings] Load Offerings Success', props<{ offerings: IOffering[] }>());
export const loadOfferingsFailure = createAction('[Offerings] Load Offerings Failure', props<{ error: string }>());

export const loadOffering = createAction('[Offerings] Load Offering', props<{ offeringId: number }>());
export const loadOfferingSuccess = createAction('[Offerings] Load Offering Success', props<{ offering: IOffering }>());
export const loadOfferingFailure = createAction('[Offerings] Load Offering Failure', props<{ error: string }>());

export const createNewOfferingDraft = createAction('[Offerings] Create New Offering Draft', props<{ companyId: number; nextSortOrder: number }>());

export const createOffering = createAction('[Offerings] Create Offering', props<{ offering: IOffering }>());
export const createOfferingSuccess = createAction('[Offerings] Create Offering Success', props<{ offering: IOffering }>());
export const createOfferingFailure = createAction('[Offerings] Create Offering Failure', props<{ error: string }>());

export const saveOffering = createAction('[Offerings] Save Offering', props<{ offering: IOffering }>());
export const saveOfferingSuccess = createAction('[Offerings] Save Offering Success', props<{ offering: IOffering }>());
export const saveOfferingFailure = createAction('[Offerings] Save Offering Failure', props<{ error: string }>());

export const deleteOffering = createAction('[Offerings] Delete Offering', props<{ offeringId: number }>());
export const deleteOfferingSuccess = createAction('[Offerings] Delete Offering Success', props<{ offeringId: number }>());
export const deleteOfferingFailure = createAction('[Offerings] Delete Offering Failure', props<{ error: string }>());

export const updateOfferingField = createAction('[Offerings] Update Offering Field', props<{ changes: Partial<IOffering> }>());
export const addDetail = createAction('[Offerings] Add Detail', props<{ detailTypeId: number }>());
export const removeDetail = createAction('[Offerings] Remove Detail', props<{ detailId: number }>());
export const moveDetailUp = createAction('[Offerings] Move Detail Up', props<{ detailId: number }>());
export const moveDetailDown = createAction('[Offerings] Move Detail Down', props<{ detailId: number }>());
export const addDetailItem = createAction('[Offerings] Add Detail Item', props<{ detailId: number }>());
export const updateDetailItem = createAction('[Offerings] Update Detail Item', props<IDetailItemChange>());
export const removeDetailItem = createAction('[Offerings] Remove Detail Item', props<IDetailItemMove>());
export const moveDetailItemUp = createAction('[Offerings] Move Detail Item Up', props<IDetailItemMove>());
export const moveDetailItemDown = createAction('[Offerings] Move Detail Item Down', props<IDetailItemMove>());
export const clearSelectedOffering = createAction('[Offerings] Clear Selected Offering');

export const OfferingsActions = createActionGroup({
    source: 'Offerings',
    events: {
        'Load Offering Contacts': props<{ offeringId: number }>(),
        'Load Offering Contacts Success': props<{ contacts: IOfferingContact[] }>(),
        'Load Offering Contacts Failure': props<{ error: string }>(),

        'Set Offering Contacts': props<{ contacts: IOfferingContact[] }>(),

        'Save Offering Contacts': props<{ offeringId: number; contacts: IOfferingContact[] }>(),
        'Save Offering Contacts Success': emptyProps(),
        'Save Offering Contacts Failure': props<{ error: string }>(),
    },
});

export const PartnerUsersActions = createActionGroup({
    source: 'Partner Users',
    events: {
        'Load Company Users': props<{ companyId: number }>(),
        'Load Company Users Success': props<{ companyId: number; users: IPartnerUser[] }>(),
        'Load Company Users Failure': props<{ error: string }>(),

        'Add Company User': props<{ companyId: number; userId: number }>(),
        'Add Company User Success': props<{ companyId: number }>(),
        'Add Company User Failure': props<{ error: string }>(),

        'Remove Company User': props<{ companyId: number; userId: number }>(),
        'Remove Company User Success': props<{ companyId: number }>(),
        'Remove Company User Failure': props<{ error: string }>(),

        'Clear Company Users': emptyProps(),
    },
});

export const AdminUserSearchActions = createActionGroup({
    source: 'Admin User Search',
    events: {
        'Search Users': props<{ query: string; partnerId: number }>(),
        'Search Users Success': props<{ query: string; results: IUserSearchResult[] }>(),
        'Search Users Failure': props<{ error: string }>(),
        'Clear Search Results': emptyProps(),
    },
});

export const MotivationalNudgeActions = createActionGroup({
    source: 'Motivational Nudge',
    events: {
        'Send Nudge': props<{ request: ISendMotivationalNudgeRequest }>(),
        'Send Nudge Success': props<{ result: ISendMotivationalNudgeResult }>(),
        'Send Nudge Failure': props<{ error: string }>(),
    },
});

export const OfferingContactsActions = createActionGroup({
    source: 'Offering Contacts',
    events: {
        'Load Offering Contacts': props<{ offeringId: number }>(),
        'Load Offering Contacts Success': props<{ offeringId: number; contacts: IOfferingContact[] }>(),
        'Load Offering Contacts Failure': props<{ error: string }>(),

        'Add Offering Contact': props<{ offeringId: number; request: IOfferingContactRequest }>(),
        'Add Offering Contact Success': props<{ offeringId: number }>(),
        'Add Offering Contact Failure': props<{ error: string }>(),

        'Update Offering Contact': props<{ offeringId: number; userId: number; request: IOfferingContactRequestBase }>(),
        'Update Offering Contact Success': props<{ offeringId: number }>(),
        'Update Offering Contact Failure': props<{ error: string }>(),

        'Delete Offering Contact': props<{ offeringId: number; userId: number }>(),
        'Delete Offering Contact Success': props<{ offeringId: number }>(),
        'Delete Offering Contact Failure': props<{ error: string }>(),

        'Clear Offering Contacts': emptyProps(),
    },
});
